module.exports = __webpack_public_path__ + "static/media/MistyBrightSky.8bce473f.env";